import React, { useState, useEffect } from 'react';
import { Button, Box, Typography, CircularProgress, TextField  } from '@mui/material';
import WorkoutList from '../features/workoutsManagement/components/WorkoutList';
import CreateWorkoutButton from '../features/workoutsManagement/components/CreateWorkoutButton';
import { getAllWorkouts, getetUserCreatedWorkouts } from '../features/workoutsManagement/services/workoutsManagementService';
import { useAuth } from '../contexts/authContext';
import { useSnackbar } from 'notistack';
import UserWorkoutsTable from '../features/workoutsManagement/components/UserWorkoutsTable';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import UserWorkoutsBlock from '../features/workoutsManagement/components/UserWorkoutsBlock';
import WorkoutsBlock from '../features/workoutsManagement/components/WorkoutsBlock';

const WorkoutPage = () => {
  const auth = useAuth();
  const [workouts, setWorkouts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [currentView, setCurrentView] = useState('all');
  const { enqueueSnackbar } = useSnackbar();

  const [searchQuery, setSearchQuery] = useState('');

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const fetchWorkouts = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = currentView === 'all' ? await getAllWorkouts() : await getetUserCreatedWorkouts(auth.user.id);
      setWorkouts(data);
      enqueueSnackbar('Workouts fetched successfully!', { variant: 'success' });
    } catch (err) {
      setError(err.message);
      enqueueSnackbar('Error fetching workouts!', { variant: 'error' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchWorkouts();
  }, [currentView]);

  const filteredWorkouts = workouts.filter(workout =>
    workout.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div>
      <Typography variant="h4" gutterBottom>
        Workout Management
      </Typography>
      <Box display="flex" justifyContent="flex-end" marginBottom={2} flexDirection={isMobile ? 'column' : 'row'}>
        <Button
          style={{ margin: '2px' }}
          variant={currentView === 'all' ? 'contained' : 'outlined'}
          onClick={() => {
            setCurrentView('all');
            setLoading(true);
          }}
        >
          All Workouts
        </Button>
        <Button
          style={{ margin: '2px' }}
          variant={currentView === 'user' ? 'contained' : 'outlined'}
          onClick={() => {
            setCurrentView('user');
            setLoading(true);
          }}
        >
          My Workouts
        </Button>
        <CreateWorkoutButton
          onSuccess={async () => {
            const updatedWorkouts = await getetUserCreatedWorkouts(auth.user.id);
            setWorkouts(updatedWorkouts);
          }}
          disabled={currentView === 'all'}
          userId={auth.user.id}
        />
      </Box>

      {isMobile && (
        <Box marginBottom={2}>
          <TextField
            label="Search Workouts"
            variant="outlined"
            fullWidth
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </Box>
      )}

      {loading ? (
        <CircularProgress />
      ) : error ? (
        <Typography color="error">{error}</Typography>
      ) : isMobile ? ( 
        <>
          {currentView === 'user' ? (
            <UserWorkoutsBlock workouts={filteredWorkouts} loading={loading} />
          ) : (
            <WorkoutsBlock workouts={filteredWorkouts} />
          )}
        </>
      ) : currentView === 'user' ? ( 
        <UserWorkoutsTable workouts={workouts} loading={loading} />
      ) : (
        <WorkoutList workouts={workouts} /> 
      )}
    </div>
  );
};

export default WorkoutPage;
